import { render, staticRenderFns } from "./jtjj.vue?vue&type=template&id=3f0689e0&"
import script from "./jtjj.vue?vue&type=script&lang=js&"
export * from "./jtjj.vue?vue&type=script&lang=js&"
import style0 from "./jtjj.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports